import { tv } from 'tailwind-variants';

const quickTipStyles = tv({
    slots: {
        quickTipContainer: `
      iris:flex
      iris:w-(--comp-size-width-quick-tip) iris:shrink-0
      iris:items-start
      iris:gap-(--comp-space-gap-quick-tip-icon)
      iris:rounded-(--comp-size-radius-quick-tip)
      iris:p-(--comp-space-padding-quick-tip-all)
      iris:font-(family-name:--comp-type-font-quick-tip-title)
    `,
        content: `
      iris:flex
      iris:flex-col
      iris:items-start
      iris:gap-(--comp-space-gap-quick-tip-text)
    `,
        title: `
      iris:self-stretch
      iris:font-(family-name:--comp-type-font-quick-tip-title)
      iris:text-(length:--comp-type-size-quick-tip-title)
      iris:leading-(--comp-type-leading-quick-tip-title)
      iris:font-(--comp-type-weight-quick-tip-title)!
      iris:tracking-(--comp-type-tracking-quick-tip-title)
      iris:[text-transform:var(--comp-type-transform-quick-tip-title)]
      iris:not-italic
    `,
        body: `
      iris:font-(family-name:--comp-type-font-quick-tip-body)
      iris:text-(length:--comp-type-size-quick-tip-body)
      iris:leading-(--comp-type-leading-quick-tip-body)
      iris:font-(--comp-type-weight-quick-tip-body)!
      iris:tracking-(--comp-type-tracking-quick-tip-body)
      iris:not-italic
    `,
        icon: `
      iris:size-(--comp-size-icon-quick-tip)
      iris:shrink-0
    `,
    },
    variants: {
        inverse: {
            true: "",
            false: "",
        },
    },
    compoundVariants: [
        {
            inverse: false,
            class: {
                quickTipContainer: "iris:bg-(--comp-color-background-quick-tip-default)",
                title: "iris:text-(--comp-color-content-quick-tip-title)",
                body: "iris:text-(--comp-color-content-quick-tip-body)",
                icon: "iris:text-(--comp-color-content-quick-tip-icon)",
            },
        },
        {
            inverse: true,
            class: {
                quickTipContainer: "iris:bg-(--comp-color-background-quick-tip-inverse)",
                title: "iris:text-(--comp-color-content-quick-tip-title-inverse)",
                body: "iris:text-(--comp-color-content-quick-tip-body-inverse)",
                icon: "iris:text-(--comp-color-content-quick-tip-icon-inverse)",
            },
        },
    ],
});

export { quickTipStyles as default };
